export enum BuildingType {
    "",
    "Appartement",
    "Rijhuis",
    "Halfopen bebouwing",
    "Open bebouwing"
}